import '../modules/consultationForm';
import testimonialsSlider from '../modules/testimonials';
import { initializeMap, customIcon, addNewMarker, getCampuses, createNewCampusBox } from '../modules/map';
import { gallery, openMediaInModal } from '../modules/gallery';

function mapWithCampuses() {
  const programID = location.pathname.split('/').pop();

  getCampuses('id', programID)
    .then(response => response.json())
    .then(result => {

      if (!result.campuses) {
        const section = document.querySelector('#school-contacts');
        section.remove();
        return
      }

      const programMap = initializeMap();
      programMap.setView([result.campuses[0].lat, result.campuses[0].long]);

      result.campuses.forEach(campus => {

        createNewCampusBox(campus.country, campus.city, campus.street, campus.lat, campus.long, programMap);

        let programs = '';
        campus.programs.forEach(program => programs += `${program.name} <br />`)

        addNewMarker(campus.lat, campus.long, customIcon, programs, programMap)

      });
    })
    .catch(error => console.log('error getting campuses', error))
}

document.addEventListener("DOMContentLoaded", () => {

  testimonialsSlider();
  gallery();
  openMediaInModal();

  //Load Map when it is in the viewport
  if ('IntersectionObserver' in window) {

    function handleIntersection(entries) {
      entries.map((entry) => {
        if (entry.isIntersecting) {
          // Item has crossed our observation
          mapWithCampuses();
          // Job done for this item - no need to watch it!
          observer.unobserve(entry.target);
        }
      });
    }

    const item = document.querySelector('#map');

    const observer = new IntersectionObserver(
      handleIntersection,
      { rootMargin: "100px" }
    );

    observer.observe(item);
} else {
  // No interaction support
  mapWithCampuses();
}

})